export enum AttachmentModes {
  Add = 'Add',
  Edit = 'Edit',
  View = 'View',
}
